import { LoadableAfterPaint, LoadableBackground } from '@confluence/loadable';
import { componentWithFG } from '@confluence/feature-gate-component';

import { HelpManagerPlaceholder } from './editor-help-menu';

export { EditorHelpCenter } from './editor-help-center';

export {
	HelpMenuClassicContext,
	HelpMenuContextProvider,
	HelpMenu,
	HelpManagerPlaceholder,
	HelpWidget,
} from './editor-help-menu';

const BackgroundHelpManagerLoader = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HelpManager" */ './HelpManager')).HelpManager,
});

const AfterPaintHelpManagerLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HelpManager" */ './HelpManager')).HelpManager,
	loading: HelpManagerPlaceholder,
});

export const HelpManagerLoader = componentWithFG(
	'confluence_frontend_editor_help_center_placeholder',
	AfterPaintHelpManagerLoader,
	BackgroundHelpManagerLoader,
);
